module.exports = __webpack_public_path__ + "img/infoSupport.c49a3076.webp";